import { render, staticRenderFns } from "./msg-item.vue?vue&type=template&id=19788b0a&scoped=true"
import script from "./msg-item.vue?vue&type=script&lang=js"
export * from "./msg-item.vue?vue&type=script&lang=js"
import style0 from "./msg-item.vue?vue&type=style&index=0&id=19788b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19788b0a",
  null
  
)

export default component.exports